import React from 'react';
import {
  Router as DefaultRouter,
  Route,
  Switch,
  StaticRouter,
} from 'react-router-dom';
import dynamic from 'umi/dynamic';
import renderRoutes from 'umi/lib/renderRoutes';
import history from '@@/history';
import RendererWrapper0 from '/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/pages/.umi-production/LocaleWrapper.jsx';
import { routerRedux, dynamic as _dvaDynamic } from 'dva';

const Router = routerRedux.ConnectedRouter;

const routes = [
  {
    path: '/user',
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () =>
            import(/* webpackChunkName: "layouts__UserLayout" */ '../../layouts/UserLayout'),
          LoadingComponent: require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/components/PageLoading/index')
            .default,
        })
      : require('../../layouts/UserLayout').default,
    routes: [
      {
        path: '/user',
        redirect: '/user/login',
        exact: true,
      },
      {
        path: '/user/login',
        name: 'login',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__User__Login" */ '../User/Login'),
              LoadingComponent: require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/components/PageLoading/index')
                .default,
            })
          : require('../User/Login').default,
        exact: true,
      },
      {
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__404" */ '../404'),
              LoadingComponent: require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/components/PageLoading/index')
                .default,
            })
          : require('../404').default,
        exact: true,
      },
    ],
  },
  {
    path: '/',
    component: __IS_BROWSER
      ? _dvaDynamic({
          component: () =>
            import(/* webpackChunkName: "layouts__BasicLayout" */ '../../layouts/BasicLayout'),
          LoadingComponent: require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/components/PageLoading/index')
            .default,
        })
      : require('../../layouts/BasicLayout').default,
    Routes: [require('../Authorized').default],
    routes: [
      {
        path: '/',
        redirect: '/marketing/analysis',
        exact: true,
      },
      {
        id: 13,
        path: '/marketing',
        name: 'marketing',
        icon: 'shopping',
        routes: [
          {
            id: 14,
            path: '/marketing/analysis',
            name: 'analysis',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__MarketingManager__models__analysis.js' */ '/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/pages/MarketingManager/models/analysis.js').then(
                      m => {
                        return { namespace: 'analysis', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__MarketingManager__models__customer.js' */ '/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/pages/MarketingManager/models/customer.js').then(
                      m => {
                        return { namespace: 'customer', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__MarketingManager__Analysis" */ '../MarketingManager/Analysis'),
                  LoadingComponent: require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/components/PageLoading/index')
                    .default,
                })
              : require('../MarketingManager/Analysis').default,
            exact: true,
          },
          {
            id: 16,
            path: '/marketing/list',
            name: 'list',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__MarketingManager__models__analysis.js' */ '/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/pages/MarketingManager/models/analysis.js').then(
                      m => {
                        return { namespace: 'analysis', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__MarketingManager__models__customer.js' */ '/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/pages/MarketingManager/models/customer.js').then(
                      m => {
                        return { namespace: 'customer', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__MarketingManager__List" */ '../MarketingManager/List'),
                  LoadingComponent: require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/components/PageLoading/index')
                    .default,
                })
              : require('../MarketingManager/List').default,
            exact: true,
          },
          {
            id: 17,
            path: '/marketing/:id',
            name: 'detail',
            hideInMenu: true,
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__MarketingManager__models__analysis.js' */ '/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/pages/MarketingManager/models/analysis.js').then(
                      m => {
                        return { namespace: 'analysis', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__MarketingManager__models__customer.js' */ '/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/pages/MarketingManager/models/customer.js').then(
                      m => {
                        return { namespace: 'customer', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__MarketingManager__CustomerDetail" */ '../MarketingManager/CustomerDetail'),
                  LoadingComponent: require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/components/PageLoading/index')
                    .default,
                })
              : require('../MarketingManager/CustomerDetail').default,
            exact: true,
          },
        ],
      },
      {
        id: 24,
        path: '/member',
        name: 'member',
        icon: 'solution',
        routes: [
          {
            id: 39,
            path: '/member/salerData',
            name: 'salerData',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__MemberManager__models__saler.js' */ '/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/pages/MemberManager/models/saler.js').then(
                      m => {
                        return { namespace: 'saler', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__MemberManager__SalerData" */ '../MemberManager/SalerData'),
                  LoadingComponent: require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/components/PageLoading/index')
                    .default,
                })
              : require('../MemberManager/SalerData').default,
            exact: true,
          },
          {
            id: 25,
            path: '/member/saler',
            name: 'saler',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__MemberManager__models__saler.js' */ '/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/pages/MemberManager/models/saler.js').then(
                      m => {
                        return { namespace: 'saler', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__MemberManager__Saler" */ '../MemberManager/Saler'),
                  LoadingComponent: require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/components/PageLoading/index')
                    .default,
                })
              : require('../MemberManager/Saler').default,
            exact: true,
          },
        ],
      },
      {
        id: 37,
        path: '/trafficReport',
        name: 'trafficReport',
        icon: 'read',
        component: __IS_BROWSER
          ? _dvaDynamic({
              app: require('@tmp/dva').getApp(),
              models: () => [
                import(/* webpackChunkName: 'p__TrafficReport__models__trafficReport.js' */ '/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/pages/TrafficReport/models/trafficReport.js').then(
                  m => {
                    return { namespace: 'trafficReport', ...m.default };
                  },
                ),
              ],
              component: () =>
                import(/* webpackChunkName: "p__TrafficReport__Report" */ '../TrafficReport/Report'),
              LoadingComponent: require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/components/PageLoading/index')
                .default,
            })
          : require('../TrafficReport/Report').default,
        exact: true,
      },
      {
        id: 18,
        path: '/developers',
        name: 'developersManager',
        icon: 'bank',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__DevelopersManager__Developers" */ '../DevelopersManager/Developers'),
              LoadingComponent: require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/components/PageLoading/index')
                .default,
            })
          : require('../DevelopersManager/Developers').default,
        exact: true,
      },
      {
        id: 19,
        path: '/building',
        name: 'buildingManager',
        icon: 'database',
        routes: [
          {
            id: 20,
            path: '/building/list',
            name: 'list',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__BuildingManager__List" */ '../BuildingManager/List'),
                  LoadingComponent: require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/components/PageLoading/index')
                    .default,
                })
              : require('../BuildingManager/List').default,
            exact: true,
          },
          {
            id: 21,
            path: '/building/:buildId',
            name: 'buildingDetail',
            hideInMenu: true,
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__BuildingManager__BuildingDetail" */ '../BuildingManager/BuildingDetail'),
                  LoadingComponent: require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/components/PageLoading/index')
                    .default,
                })
              : require('../BuildingManager/BuildingDetail').default,
            exact: true,
          },
          {
            id: 22,
            path: '/building/:buildId/rooms/:roomId',
            name: 'buildingRoom',
            hideInMenu: true,
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__BuildingManager__RoomDetial" */ '../BuildingManager/RoomDetial'),
                  LoadingComponent: require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/components/PageLoading/index')
                    .default,
                })
              : require('../BuildingManager/RoomDetial').default,
            exact: true,
          },
          {
            id: 23,
            path: '/building/:buildId/rooms/:roomId/:pointId/:level',
            name: 'buildingRoom.robotPoint',
            hideInMenu: true,
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__BuildingManager__RoomPoint" */ '../BuildingManager/RoomPoint'),
                  LoadingComponent: require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/components/PageLoading/index')
                    .default,
                })
              : require('../BuildingManager/RoomPoint').default,
            exact: true,
          },
          {
            id: 122,
            path: '/building/:buildId/rooms/:roomId/:id',
            name: 'robotLoaclGuide',
            hideInMenu: true,
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__BuildingManager__RobotLoaclGuide" */ '../BuildingManager/RobotLoaclGuide'),
                  LoadingComponent: require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/components/PageLoading/index')
                    .default,
                })
              : require('../BuildingManager/RobotLoaclGuide').default,
            exact: true,
          },
        ],
      },
      {
        id: 38,
        path: '/miniProgram',
        name: 'miniProgram',
        icon: 'setting',
        routes: [
          {
            id: 29,
            path: '/miniProgram/miniprogram',
            name: 'miniprogram',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__MiniProgram__MiniProgram" */ '../MiniProgram/MiniProgram'),
                  LoadingComponent: require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/components/PageLoading/index')
                    .default,
                })
              : require('../MiniProgram/MiniProgram').default,
            exact: true,
          },
          {
            id: 121,
            path: '/miniProgram/h5setting',
            name: 'h5setting',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__MiniProgram__H5Setting" */ '../MiniProgram/H5Setting'),
                  LoadingComponent: require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/components/PageLoading/index')
                    .default,
                })
              : require('../MiniProgram/H5Setting').default,
            exact: true,
          },
          {
            id: 27,
            path: '/miniProgram/robot/:id/:serial',
            name: 'robot',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  component: () =>
                    import(/* webpackChunkName: "p__Terminal__RobotManager" */ '../Terminal/RobotManager'),
                  LoadingComponent: require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/components/PageLoading/index')
                    .default,
                })
              : require('../Terminal/RobotManager').default,
            exact: true,
          },
        ],
      },
      {
        id: 30,
        path: '/account-manager',
        name: 'accountManager',
        icon: 'apartment',
        routes: [
          {
            id: 31,
            path: '/account-manager/user',
            name: 'User',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__AccountManager__models__account.js' */ '/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/pages/AccountManager/models/account.js').then(
                      m => {
                        return { namespace: 'account', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__AccountManager__models__role.js' */ '/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/pages/AccountManager/models/role.js').then(
                      m => {
                        return { namespace: 'role', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__AccountManager__Account" */ '../AccountManager/Account'),
                  LoadingComponent: require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/components/PageLoading/index')
                    .default,
                })
              : require('../AccountManager/Account').default,
            exact: true,
          },
          {
            id: 32,
            path: '/account-manager/role',
            name: 'Role',
            component: __IS_BROWSER
              ? _dvaDynamic({
                  app: require('@tmp/dva').getApp(),
                  models: () => [
                    import(/* webpackChunkName: 'p__AccountManager__models__account.js' */ '/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/pages/AccountManager/models/account.js').then(
                      m => {
                        return { namespace: 'account', ...m.default };
                      },
                    ),
                    import(/* webpackChunkName: 'p__AccountManager__models__role.js' */ '/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/pages/AccountManager/models/role.js').then(
                      m => {
                        return { namespace: 'role', ...m.default };
                      },
                    ),
                  ],
                  component: () =>
                    import(/* webpackChunkName: "p__AccountManager__Role" */ '../AccountManager/Role'),
                  LoadingComponent: require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/components/PageLoading/index')
                    .default,
                })
              : require('../AccountManager/Role').default,
            exact: true,
          },
        ],
      },
      {
        path: '/personal',
        name: 'personal',
        icon: 'user',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__Personal__index" */ '../Personal/index'),
              LoadingComponent: require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/components/PageLoading/index')
                .default,
            })
          : require('../Personal/index').default,
        auth: true,
        exact: true,
      },
      {
        path: '/nlp',
        name: 'NLP',
        icon: 'setting',
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__NLP__index" */ '../NLP/index'),
              LoadingComponent: require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/components/PageLoading/index')
                .default,
            })
          : require('../NLP/index').default,
        auth: true,
        exact: true,
      },
      {
        component: __IS_BROWSER
          ? _dvaDynamic({
              component: () =>
                import(/* webpackChunkName: "p__404" */ '../404'),
              LoadingComponent: require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/components/PageLoading/index')
                .default,
            })
          : require('../404').default,
        exact: true,
      },
    ],
  },
];
window.g_routes = routes;
const plugins = require('umi/_runtimePlugin');
plugins.applyForEach('patchRoutes', { initialValue: routes });

export { routes };

export default class RouterWrapper extends React.Component {
  unListen() {}

  constructor(props) {
    super(props);

    // route change handler
    function routeChangeHandler(location, action) {
      plugins.applyForEach('onRouteChange', {
        initialValue: {
          routes,
          location,
          action,
        },
      });
    }
    this.unListen = history.listen(routeChangeHandler);
    // dva 中 history.listen 会初始执行一次
    // 这里排除掉 dva 的场景，可以避免 onRouteChange 在启用 dva 后的初始加载时被多执行一次
    const isDva =
      history.listen
        .toString()
        .indexOf('callback(history.location, history.action)') > -1;
    if (!isDva) {
      routeChangeHandler(history.location);
    }
  }

  componentWillUnmount() {
    this.unListen();
  }

  render() {
    const props = this.props || {};
    return (
      <RendererWrapper0>
        <Router history={history}>{renderRoutes(routes, props)}</Router>
      </RendererWrapper0>
    );
  }
}
